<template>
	<el-container>
		<el-header>
			<!-- <img style="margin-top: 12px;max-width: 40px; float: left;" @click="toback()"
				:src='"/img/webimg/back.png"' alt=""> -->
			<el-button style="margin-top: 4px;font-size: 28px; float: left;color:#000000;" @click="toback()" icon="el-icon-arrow-left" type="text"></el-button>
			<span class="header_h2">个人信息 </span>
		</el-header>
		<el-row>
			<span class="header_h2">{{OrderName}}</span>
		</el-row>
		<el-row type="flex" justify="center">
			<div style=" width: 300px;">
				<el-form :model="EditInfo" ref="EditInfo" label-width="80px">

					<el-form-item required>
						<label slot="label">姓&emsp;&emsp;名</label>
						<el-input style="border: none;" type="text" size="small" v-model="EditInfo.cusname"
							placeholder="请输入姓名"></el-input>

					</el-form-item>

					<el-form-item required>
						<label slot="label">性&emsp;&emsp;别</label>
						<el-radio v-model="EditInfo.cussex" label="1">男</el-radio>
						<el-radio v-model="EditInfo.cussex" label="2">女</el-radio>
					</el-form-item>
					<el-form-item required>
						<label slot="label">婚&emsp;&emsp;否</label>
						<el-radio-group size="small" v-model="EditInfo.cusmarry">

							<el-radio-button :label="2">未婚</el-radio-button>
							<el-radio-button :label="1">已婚</el-radio-button>
						</el-radio-group>
						<!-- <el-select size="small" v-model="EditInfo.cusmarry">
							<el-option v-for="item in this.$enums.Marry" :label="item.key" :value="item.value" placeholder="请选择">
								{{ item.key }}
							</el-option>
						</el-select> -->
					</el-form-item>
					<el-form-item label="出生日期" required>
						<label slot="label">出生日期</label>
						<el-date-picker type="date" size="small" v-model="EditInfo.cusbirthday" format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="证 件 号">
						<label slot="label">证&ensp;件&ensp;号</label>
						<el-input size="small" v-model="EditInfo.idcard" placeholder="请输入证件号"></el-input>
					</el-form-item>
					<el-form-item>
						<label slot="label">&ensp;备&emsp;&emsp;注</label>
						<el-input size="small" v-model="EditInfo.memo"></el-input>
					</el-form-item>
					<!-- <el-button type="primary" style="float: right;" @click="btnEditCus()">下一步</el-button> -->
				</el-form>

			</div>
		</el-row>
		<el-row>
			<el-button style="width: 90%;font-size: 20px;" type="primary" @click="btnEditCus()">下一步</el-button>
		</el-row>

	</el-container>
</template>

<script>
	import order from '../../apifunction/Order.js'
	import ordercus from '../../apifunction/OrderCus.js'
	import checkidcard from '../../commontools/checkIDcard.js'
	export default {
		data() {
			return {
				emSex: this.$enums.Sex,
				emMarry: this.$enums.Marry,
				cusent: null,
				OrderName: '',
				EditInfo: {
					id: '',
					cusname: '',
					cussex: '1',
					cusbirthday: '',
					cusmarry: '3',
					mobile: '',
					idcard: '',
					cusstatus: '10',
					memo: '',
					orderid: '',
					groupid: '',
					corpid: ''
				},
				// rules: {
				//           cusname: [
				//             { required: true, message: '请输入姓名', trigger: 'blur' },
				//             // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
				//           ],
				//           cusbirthday: [
				//             { type: 'date', required: true, message: '请选择出生日期', trigger: 'change' }
				//           ],}
			}
		},
		created() {
			var ent = this.$route.query.ent;
			this.cusent = JSON.parse(ent);
			this.InitData();

		},
		methods: {
			toback()
			{
					var data = {
						path: '/BookCusList',
						query: {
							mobile: this.cusent.mobile
						}
					}
					this.$router.push(data)
			
			},
			InitData() {
				this.setcusinfo();
				this.getordername(this.cusent.orderid);
				this.idcardonblur();
			},
			idcardonblur() {
				if (this.cusent.idcard == "")
					return;
				let b = checkidcard.checkCard(this.cusent.idcard);
				if (b) {

					this.EditInfo.cusbirthday = checkidcard.baseInfo.birthday;
					this.EditInfo.cussex = checkidcard.baseInfo.sex;
				}
			},
			setcusinfo() {
				ordercus.GetOrderCusByCusID(this.cusent.id)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								let row = JSON.parse(ent.Data)[0];
								this.EditInfo = {
									id: row.id,
									cusname: row.cusname,
									cussex: row.cussex,
									cusbirthday: row.cusbirthday,
									cusmarry: row.cusmarry,
									mobile: row.mobile,
									idcard: row.idcard,
									cusstatus: row.cusstatus,
									memo: row.memo,
									orderid: row.orderid,
									groupid: row.groupid,
									corpid: row.corpid
								};
							}
						}
					})

			},
			btnEditCus() {
				if (this.EditInfo.cusname == "" || this.EditInfo.cussex == "" || this.EditInfo.cusbirthday == "" || (this
						.EditInfo.cusmarry != '1' && this.EditInfo.cusmarry != '2')) {
					this.$message.info('请填写姓名、性别、婚否及出生日期！');
					return;
				}
				this.EditInfo.cusbirthday = this.CommonFun.formatdate(this.EditInfo.cusbirthday)
				ordercus.EditCus(this.EditInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							var data = {
								path: '/BookGroupSel',
								query: {
									ent: JSON.stringify(this.EditInfo)
								}
							};
							this.$router.push(data)

						} else
							this.$message.info(ent.Msg);
					})
			},
			getordername(orderid) {
				order.GetOrderByID(orderid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.orderent = JSON.parse(ent.Data)[0];
								this.OrderName = this.orderent.OrderName
							}
						}
					})
			},
		}
	}
</script>

<style>
</style>
